import 'angular:locale/data:en-US';
import './src/polyfills.ts';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en-US";
